import { Instagram, Facebook, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-[#2A1408] text-[#F5E6D3] border-t-4 border-[#B07B66]">
            <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">
                <div>
                    <p className="font-handwritten text-3xl text-[#C99889] leading-none">
                        le comptoir du
                    </p>
                    <p
                        className="font-display text-5xl tracking-tight"
                        style={{ fontWeight: 800 }}
                    >
                        COOKIE
                    </p>
                    <p className="text-sm mt-3 text-[#E4D1BB] max-w-xs">
                        Cookies artisanaux, salon de thé, évènements.
                        <br />
                        Made in Mâcon, since 2021.
                    </p>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-widest text-[#C99889] font-bold mb-4">
                        Nos boutiques
                    </p>
                    <ul className="space-y-2 text-sm">
                        <li className="flex items-start gap-2">
                            <MapPin size={16} className="mt-0.5 shrink-0" strokeWidth={2} />
                            <span>Mâcon, centre-ville</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <MapPin size={16} className="mt-0.5 shrink-0" strokeWidth={2} />
                            <span>Bourg-en-Bresse, centre-ville</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-widest text-[#C99889] font-bold mb-4">
                        Suivez-nous
                    </p>
                    <div className="flex items-center gap-4">
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-instagram"
                            className="w-11 h-11 rounded-full border-2 border-[#C99889] flex items-center justify-center hover:bg-[#C99889] hover:text-[#2A1408] transition-colors"
                        >
                            <Instagram size={18} strokeWidth={2} />
                        </a>
                        <a
                            href="https://facebook.com"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-facebook"
                            className="w-11 h-11 rounded-full border-2 border-[#C99889] flex items-center justify-center hover:bg-[#C99889] hover:text-[#2A1408] transition-colors"
                        >
                            <Facebook size={18} strokeWidth={2} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-[#5C3D2E] py-4 px-6">
                <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#C99889] text-center md:text-left">
                    <p data-testid="footer-copyright">
                        © {new Date().getFullYear()} Le Comptoir du Cookie, Tous droits réservés.
                    </p>
                    <nav className="flex items-center gap-5" data-testid="footer-legal-nav">
                        <Link
                            to="/mentions-legales"
                            className="hover:text-[#F5E6D3] transition-colors"
                            data-testid="footer-mentions"
                        >
                            Mentions légales
                        </Link>
                        <span className="opacity-40">•</span>
                        <Link
                            to="/politique-de-confidentialite"
                            className="hover:text-[#F5E6D3] transition-colors"
                            data-testid="footer-politique"
                        >
                            Politique de confidentialité
                        </Link>
                    </nav>
                    <p data-testid="footer-credit">
                        Site conçu et réalisé par{" "}
                        <a
                            href="https://axeris-labs.fr"
                            target="_blank"
                            rel="noreferrer"
                            className="underline decoration-[#D6552C] underline-offset-2 hover:text-[#F5E6D3]"
                        >
                            Axeris Labs
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
